import React from 'react';

export default ({ color = '#525979', size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99992 14.6663C4.31802 14.6663 1.33325 11.6815 1.33325 7.99967C1.33325 4.31777 4.31802 1.33301 7.99992 1.33301C11.6818 1.33301 14.6666 4.31777 14.6666 7.99967C14.6666 11.6815 11.6818 14.6663 7.99992 14.6663ZM6.47327 13.1113C5.83154 11.7503 5.43813 10.2491 5.35146 8.66634H2.70785C2.97192 10.784 4.47751 12.5161 6.47327 13.1113ZM6.68705 8.66634C6.78732 10.2922 7.25178 11.8195 7.99992 13.1677C8.74805 11.8195 9.21252 10.2922 9.31279 8.66634H6.68705ZM13.292 8.66634H10.6484C10.5617 10.2491 10.1683 11.7503 9.52658 13.1113C11.5223 12.5161 13.0279 10.784 13.292 8.66634ZM2.70785 7.33301H5.35146C5.43813 5.75019 5.83154 4.24905 6.47327 2.88805C4.47751 3.48323 2.97192 5.21534 2.70785 7.33301ZM6.68705 7.33301H9.31279C9.21252 5.70715 8.74805 4.17984 7.99992 2.83167C7.25178 4.17984 6.78732 5.70715 6.68705 7.33301ZM9.52658 2.88805C10.1683 4.24905 10.5617 5.75019 10.6484 7.33301H13.292C13.0279 5.21534 11.5223 3.48323 9.52658 2.88805Z"
      fill={color}
    />
  </svg>
);
